import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  quote: 'Hice mis primeras 12 macetas de terrazo en dos semanas. Con el tomo de proveedores evité comprar cemento de mala calidad en una ferretería cara. Las vendí todas en una semana por Instagram.',
  name: 'Mariana V.',
  location: 'Rosario · Decoración Minimalista',
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/b45efa96-61bc-4773-a5ea-e9fda994a79f.jpg'
}, {
  quote: 'La calculadora de costos me salvó. Vendía una maceta de $8.000 que me costaba $5.200 fabricar. Subí los precios a $18.000 y la gente igual compró. Antes trabajaba casi gratis.',
  name: 'Rodrigo T.',
  location: 'Córdoba · Objetos Industriales',
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/3cb3bce4-7874-4a29-8165-93ae4978e41e.jpg'
}, {
  quote: 'El tomo de Meta Ads para decoración es increíble. Con un presupuesto mínimo conseguí mis primeros pedidos de personas que no me conocían. Mi taller ya tiene identidad propia y agenda llena.',
  name: 'Carolina S.',
  location: 'Buenos Aires · Deco Boutique',
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/90d50ad7-ad7b-48a3-bf4c-84ca943ecc39.jpg'
}];
export function Testimonials() {
  return <section aria-label="Testimonios" className="bg-ink" data-id="element-152" data-mp="c73r1g2h1ul3">
      <div className="mx-auto max-w-6xl px-5 pt-[47px] pb-16 sm:pb-20" data-id="element-153" data-mp="zw656dxwd5au">
        <h2 className="text-center font-display text-3xl font-black text-white sm:text-4xl" data-id="element-154" data-mp="14vj1rqeklqqm">
          💬 Lo que dicen los que ya lo aplicaron
        </h2>
        <div className="mt-10 grid w-full grid-cols-1 gap-5 sm:mt-12 md:grid-cols-3 md:gap-6" data-id="element-155" data-mp="q63eike903fo">
          {testimonials.map((t, i) => <motion.figure key={t.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="flex min-h-[230px] flex-col rounded-2xl border border-white/10 bg-ink-2 p-6 sm:min-h-[250px]" data-id="element-156" data-mp="1ivad1jdpct0x" data-mpi={i}>
              <div className="flex gap-0.5 text-gold" data-id="element-157" data-mp="1ohavsir6erqq">
                {Array.from({
              length: 5
            }).map((_, k) => <StarIcon key={k} className="h-4 w-4 fill-current" data-id="element-158" data-mp="1jir8adwxp7w9" data-mpi={k} />)}
              </div>
              <blockquote className="mt-4 flex-1 text-[15px] leading-relaxed text-white/80" data-id="element-159" data-mp="1ejem7vdw04uq">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3 border-t border-white/10 pt-4" data-id="element-160" data-mp="19r3j6jnuo2xy">
                <img src={t.img} alt={t.name} className="h-11 w-11 rounded-full object-cover ring-2 ring-gold/50" data-id="element-161" data-mp="14tlej5gv89vr" />
                <div data-id="element-162" data-mp="vs40dsn0qi9p">
                  <div className="text-sm font-bold text-white" data-id="element-163" data-mp="vuhr5pao18bg">{t.name}</div>
                  <div className="text-xs text-white/50" data-id="element-164" data-mp="qu2d0vik7wsf">📍 {t.location}</div>
                </div>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}